// import components
import CampingForm from '@/components/reserve/forms/Camping'
import Camping from '@/components/reserve/Camping'
import Parking from '@/components/reserve/Parking'
import ParkingForm from '@/components/reserve/forms/Parking'
import PassForm from '@/components/reserve/forms/Passes'
import Passes from '@/components/reserve/Passes'
import Other from '@/components/reserve/forms/Other'

export default [
  {
    path: 'camping',
    components: {
      form: CampingForm,
      results: Camping
    }
  },
  {
    path: 'parking',
    components: {
      form: ParkingForm,
      results: Parking
    }
  },
  {
    path: 'passes',
    components: {
      form: PassForm,
      results: Passes
    }
  },
  {
    path: 'other',
    components: {
      form: Other
    }
  }
]
